import React, { useState, useEffect, useRef } from "react";

import styles from "./ProjectExclusion.module.css";
import DynamicTable from "@atlaskit/dynamic-table";
import Modal, {
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  ModalTransition,
} from "@atlaskit/modal-dialog";
import Button from "@atlaskit/button";
import {
  TableWrapper,
  createCells,
  createHead,
} from "../../components/ProjectExclusion/Table/ProjectExclusionTable";
import { API } from "../../utility/Api";
import { UseToast } from "../../components/context/ToastContext";
import ProgressBar from "@atlaskit/progress-bar";
import SearchIcon from "@atlaskit/icon/glyph/search";
import CrossCircleIcon from "@atlaskit/icon/glyph/cross-circle";
import Textfield from "@atlaskit/textfield";
import Form, { Field } from "@atlaskit/form";
import { Checkbox } from "@atlaskit/checkbox";
import Lozenge from "@atlaskit/lozenge";
const ProjectExclusion = (props) => {
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [projectList, setProjectList] = useState([]);
  const [includedCount, setIncludedCount] = useState(0);
  const [excludedCount, setExcludedCount] = useState(0);
  const [globalCheckState, setGlobalCheckState] = useState({
    allChecked: true,
    indeterminate: false,
    disabled: false,
  });
  const { setMainMessage } = UseToast();
  const [isloading, setLoading] = useState(false);
  const [displayProgressBar, setDisplayProgressBar] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [isChecked, setChecked] = useState(false);
  const [checkedProjects, setCheckedProjects] = useState([]);
  const [data, setData] = useState([]);
  const validate = useRef("");

  useEffect(() => {
    const getData = async (token) => {
      setMainMessage("");
      setLoading(true);
      await API.get(`api/exclude_projects`, {
        headers: {
          Authorization: `JWT ${token}`,
        },
      })
        .then(function (response) {
          setProjectList(response.data.projects);
          setData(response.data.projects);
          setIncludedCount(
            response.data.projects.length - response.data.excludedProjectsCount
          );
          setExcludedCount(response.data.excludedProjectsCount);
          setCheckedProjects(
            response.data.projects.filter((ele) => ele.isExcluded === false)
          );
          if (
            response.data.excludedProjectsCount > 0 ||
            response.data.projects.length === 0
          ) {
            setGlobalCheckState({
              allChecked: false,
            });
          }
          setLoading(false);
        })
        .catch(function (error) {
          setMainMessage({ appearance: "error", data: error.message });
          setLoading(false);
        });
    };
    // if (projectList.length !== 0) {
    //   setLoading(true);
    //   setGlobalCheckState({
    //     indeterminate: false,
    //     allChecked: true,
    //     disabled: false,
    //   });
    // }
    //eslint-disable-next-line
    AP.context.getToken(function (token) {
      getData(token);
    });
  }, []);

  // useEffect(() => {}, [searchText]);

  const handleCheckboxCheckAll = (e) => {
    if (!e.target.checked) {
      setGlobalCheckState({
        allChecked: false,
        indeterminate: false,
        disabled: false,
      });

      if (validate.current !== "") {
        // const checked = checkedProjects;
        // projectList.map((ele) => {
        //   const findIndex = checked.findIndex((a) => a.id === ele.projectId);
        //   findIndex !== -1 && checked.splice(findIndex, 1);
        //   return checked;
        // });
        //Removing the projects deselected by the user.
        let matchList = checkedProjects;
        let newCheckedList = projectList.reduce((acc, proj) => {
          const matches = matchList.filter(
            (checkedProj) => checkedProj.projectId !== proj.projectId
          );

          // if (matches.length > 0) {
          //   acc = acc.concat(matches);
          matchList = matches;
          // }

          return matchList;
        }, []);
        setCheckedProjects(newCheckedList);
        setIncludedCount(newCheckedList.length);
        setExcludedCount(data.length - newCheckedList.length);
      } else {
        setCheckedProjects([]);
        setIncludedCount(0);
        setExcludedCount(data.length);
      }
    } else {
      if (validate.current !== "") {
        const checked = checkedProjects;
        projectList.map((ele) => {
          if (!checkedProjects.includes(ele)) checked.push(ele);
          return checked;
        });
        setCheckedProjects(checked);
        setGlobalCheckState({
          allChecked: true,
          indeterminate: false,
          disabled: false,
        });
        setIncludedCount(checked.length);
        setExcludedCount(data.length - checked.length);
      } else {
        setGlobalCheckState({
          allChecked: true,
          indeterminate: false,
          disabled: false,
        });
        checkedProjects.splice(0, checkedProjects.length);
        setCheckedProjects(data);
        setIncludedCount(data.length);
        setExcludedCount(0);
      }
    }
  };

  const handleCheckboxCheck = (e, row) => {
    if (e.target.checked) {
      if (checkedProjects.length === data.length - 1) {
        setGlobalCheckState({
          allChecked: true,
          indeterminate: false,
          disabled: false,
        });
      } else
        setGlobalCheckState({
          allChecked: false,
          indeterminate: true,
          disabled: false,
        });
      checkedProjects.push(row);
      setIncludedCount((prev) => prev + 1);
      if (excludedCount > 0) setExcludedCount((prev) => prev - 1);
    } else {
      let afterUncheckList = checkedProjects.filter(
        (ele) => ele.projectId !== row.projectId
      );
      setCheckedProjects(afterUncheckList);
      if (globalCheckState.allChecked)
        setGlobalCheckState({
          ...globalCheckState,
          allChecked: false,
        });
      else {
        if (checkedProjects.length === 0)
          setGlobalCheckState({
            ...globalCheckState,
            allChecked: false,
            indeterminate: false,
          });
      }
      setIncludedCount((prev) => prev - 1);
      setExcludedCount((prev) => prev + 1);
    }
  };

  const head = createHead(
    true,
    handleCheckboxCheckAll,
    isloading,
    globalCheckState,
    checkedProjects,
    data,
    false
  );
  const rows = createCells(
    projectList,
    handleCheckboxCheck,
    checkedProjects,
    false
  );

  const searchResult = (toSearch) => {
    const lowercasedValue = toSearch.toLowerCase();
    const filteredData = data.filter((el) =>
      el.projectName.toLowerCase().includes(lowercasedValue)
    );
    //check if projects in filteredData are already checkedProjects
    const bol = filteredData.every((ele) => checkedProjects.includes(ele));
    if (bol && filteredData && filteredData.length !== 0)
      setGlobalCheckState({
        allChecked: true,
        indeterminate: false,
        disabled: false,
      });
    else {
      setGlobalCheckState({
        allChecked: false,
        indeterminate: false,
        disabled: false,
      });
    }
    setProjectList(filteredData);
  };

  const getChangedProjects = () => {
    let matchList = data;
    let excludedList = [];
    if (checkedProjects.length === 0) excludedList = data;
    else {
      excludedList = checkedProjects.reduce((acc, proj) => {
        const matches = matchList.filter(
          (checkedProj) => checkedProj.projectId !== proj.projectId
        );
        matchList = matches;
        return matchList;
      }, []);
    }
    //newlyIncludedProjects will include the projects that were changed from excluded to included
    let newlyIncludedProjects = [];
    checkedProjects.forEach((ele) => {
      if (data[data.indexOf(ele)].isExcluded === true)
        newlyIncludedProjects.push(ele);
    });
    //newlyExcludedProjects will include the projects that were changed from included to excluded
    let newlyExcludedProjects = [];
    excludedList.forEach((ele) => {
      if (data[data.indexOf(ele)].isExcluded === false)
        newlyExcludedProjects.push(ele);
    });
    return { newlyExcludedProjects, newlyIncludedProjects };
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.subContainer}>
        <ModalTransition>
          {showConfirmation && (
            <Modal onClose={() => setShowConfirmation(false)}>
              <ModalHeader>
                <ModalTitle>Confirm Settings</ModalTitle>
              </ModalHeader>
              <ModalBody>
                <div>Verify the selected settings before proceeding.</div>
              </ModalBody>
              <ModalFooter>
                <Button
                  appearance="subtle"
                  onClick={() => setShowConfirmation(false)}
                >
                  Cancel
                </Button>
                <Button
                  onClick={() => {
                    const { newlyExcludedProjects, newlyIncludedProjects } =
                      getChangedProjects();
                    props.handleFinish(
                      newlyExcludedProjects.map((val) => {
                        return {
                          projectId: val.projectId,
                          projectName: val.projectName,
                        };
                      }),
                      newlyIncludedProjects.map((val) => {
                        return {
                          projectId: val.projectId,
                          projectName: val.projectName,
                        };
                      })
                    );
                    setShowConfirmation(false);
                    setDisplayProgressBar(true);
                  }}
                  appearance="primary"
                  autoFocus
                >
                  Confirm
                </Button>
              </ModalFooter>
            </Modal>
          )}
        </ModalTransition>
        <div className={styles.pageTitle}>
          One last step, configure which Jira software projects get backed up.
        </div>
        <div className={styles.rowContainer}>
          <div className={styles.textContainer}>
            <div className={styles.text}>
              By default we will back-up all Jira Software projects. Any new
              Jira Software projects created in the future will be automatically
              backed-up unless you exclude them.
            </div>
            <div className={styles.text}>
              Use the table to exclude projects you don’t want to backup.
            </div>
          </div>
          <div className={styles.tableContainer}>
            <TableWrapper>
              <DynamicTable
                caption={
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginBottom: "20px",
                    }}
                  >
                    <div className={styles.count}>
                      <div>Project List({data.length})</div>
                      <div
                        style={{
                          fontSize: "12px",
                          display: "flex",
                          flexDirection: "column",
                          gap: "5px",
                        }}
                      >
                        <div>
                          Included: &nbsp;
                          {
                            <Lozenge
                              // appearance={"success"}
                              isBold
                              style={{
                                padding: "20px",
                                backgroundColor: "#B3D4FF",
                                color: "black",
                              }}
                            >
                              {includedCount}
                            </Lozenge>
                          }
                        </div>
                        <div>
                          Excluded:&nbsp;
                          {
                            <Lozenge
                              // appearance={"removed"}
                              isBold
                              style={{
                                padding: "20px",
                                backgroundColor: "#B3F5FF",
                                color: "black",
                              }}
                            >
                              {excludedCount}
                            </Lozenge>
                          }
                        </div>
                      </div>
                    </div>
                    <Form
                      onSubmit={(data) => {
                        setSearchText(data.searchText);
                        searchResult(data.searchText);
                      }}
                      isDisabled={isloading}
                    >
                      {({ formProps }) => (
                        <form {...formProps}>
                          <div className={styles.filterItem}>
                            <Field
                              name="searchText"
                              defaultValue={searchText}
                              // validate={async (value) => {
                              //   const regexp = new RegExp("^[ A-Za-z0-9@#_-]*$");
                              //   if (regexp.test(value)) {
                              //     return undefined;
                              //   } else {
                              //     return "Please Enter Valid Search Text";
                              //   }
                              // }}
                            >
                              {({ fieldProps, error }) => (
                                <>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      flexDirection: "row",
                                      gap: "2px",
                                      width: "60%",
                                    }}
                                  >
                                    <Textfield
                                      elemAfterInput={
                                        <div
                                          style={{
                                            paddingRight: "6px",
                                            lineHeight: "100%",
                                          }}
                                        >
                                          <SearchIcon
                                            size="small"
                                            borderColor="transparent"
                                          />
                                        </div>
                                      }
                                      placeholder="Search project"
                                      {...fieldProps}
                                      onChange={(value) => {
                                        setSearchText(value.target.value);
                                        searchResult(value.target.value);
                                        fieldProps.onChange(value);
                                        validate.current = value.target.value;
                                      }}
                                    />
                                    {searchText.length !== 0 && (
                                      <Button
                                        size="small"
                                        appearance="subtle"
                                        onClick={() => {
                                          setSearchText("");
                                          searchResult("");
                                        }}
                                      >
                                        <CrossCircleIcon
                                          size="small"
                                          borderColor="transparent"
                                        />
                                      </Button>
                                    )}
                                  </div>
                                </>
                              )}
                            </Field>
                          </div>
                        </form>
                      )}
                    </Form>
                  </div>
                }
                head={head}
                rows={rows}
                rowsPerPage={5}
                defaultPage={1}
                loadingSpinnerSize="large"
                isLoading={isloading}
                isFixedSize
                defaultSortKey="ProjectName"
                defaultSortOrder="ASC"
                emptyView={<strong>No projects found</strong>}
              />
            </TableWrapper>
          </div>
        </div>
        <div className={styles.agreeContainer}>
          <div
            style={{
              dispay: "flex",
              flexFlow: "column wrap",
              gap: "5px",
            }}
          >
            <Checkbox
              isChecked={isChecked}
              label="I agree to all settings"
              onChange={() => {
                setChecked(!isChecked);
              }}
              name="checkbox-default"
              testId="cb-default"
            />
            <div style={{ color: "grey", marginLeft: "1.8rem" }}>
              First backup gets triggered as soon as 'Setup' is complete,
              subsequent backups are automatically scheduled starting 12.00 AM
              UTC.
            </div>
          </div>
        </div>
        <div className={styles.buttonContainer}>
          <Button
            appearance="default"
            onClick={() => {
              props.setNext(true);
              props.setProjectPage(false);
            }}
          >
            Back
          </Button>
          <Button
            appearance="primary"
            isDisabled={!isChecked}
            onClick={() => {
              setShowConfirmation(true);
            }}
          >
            Finish
          </Button>
        </div>
        {displayProgressBar && (
          <div style={{ width: "94%" }}>
            <ProgressBar isIndeterminate />
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectExclusion;
